import t from "@/lang/lang";
import {
  BaseDataPage,
  BaseDataPageContent,
  BaseDataPageDescription,
  BaseDataPageHeader,
  BaseDataPageTitle,
} from "@/routes/base-data/_components/layout/base-data-page";
import { EditCatalogCard } from "@/services/backend/textblocks/components/edit-catalog-card";
import { useTextblocksCatalogShowQuery } from "@/services/backend/textblocks/api/catalog-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { Button } from "@/shared/components/ui/button";
import { CardSkeleton } from "@/shared/components/card-skeleton";
import { PersistenceContextProvider } from "@/shared/lib/persistence-state/provider";
import { ArrowLeft } from "lucide-react";
import { NavLink, useNavigate, useParams } from "react-router";

export function CatalogRoute() {
  const { catalogId } = useParams();
  const navigate = useNavigate();
  const {
    data: catalog,
    isLoading,
    error,
  } = useTextblocksCatalogShowQuery({ id: catalogId! });

  if (isLoading) {
    return <CardSkeleton />;
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  return (
    <PersistenceContextProvider>
      <BaseDataPage>
        <BaseDataPageHeader>
          <BaseDataPageTitle>{t("Bemerkungen")}</BaseDataPageTitle>
          <BaseDataPageDescription>
            {t(
              "Hier können Kataloge für Bemerkungen konfiguriert werden. Diese Bemerkungen können dann in Vorgängen ausgewählt werden.",
            )}
          </BaseDataPageDescription>
        </BaseDataPageHeader>
        <BaseDataPageContent>
          <NavLink to="../">
            <Button variant="outline" className="mb-2">
              <ArrowLeft />
              <span>{t("Zurück zur Übersicht")}</span>
            </Button>
          </NavLink>
          {/* Key is needed to re-render card fully and update local state in it. */}
          <EditCatalogCard
            catalog={catalog!}
            key={catalog!.id}
            onDeleted={() => navigate("..")}
          />
        </BaseDataPageContent>
      </BaseDataPage>
    </PersistenceContextProvider>
  );
}
